// extracted by mini-css-extract-plugin
module.exports = {"RedButton":"RedButton_RedButton__l_R2k"};